import { Footer } from "components/common/parts/footerUnauth";
import { FormLinkRecord } from "components/common/parts/formRecord";
import * as pageInfo from "constants/pageInfo";
import React from "react";

/** 成功完了画面 */
export default function Successful(props) {
    document.title = pageInfo.LOGIN.title;

    return (
        <main>
            <div className="l-loginField">
                <div className="l-loginField l-left_area"></div>
                <div className="l-loginField l-right_area">
                    <div className="l-loginField-component">
                        <form>
                            <div className="loginField loginField--main">
                                <div className="loginField-read">
                                    パスワードが変更されました。<br />
                                    ログインしなおしてください。
                                </div>
                                <FormLinkRecord isCenter to={pageInfo.LOGIN.path}>ログイン画面へ戻る</FormLinkRecord>
                            </div>
                        </form>
                    </div>
                    <Footer />
                </div>
            </div>
        </main>
    );
}
